var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 6,
    fill: "#F3E1F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 6.5H7.25C6.65326 6.5 6.08097 6.73705 5.65901 7.15901C5.23705 7.58097 5 8.15326 5 8.75V16.25C5 16.8467 5.23705 17.419 5.65901 17.841C6.08097 18.2629 6.65326 18.5 7.25 18.5H17.75C18.3467 18.5 18.919 18.2629 19.341 17.841C19.7629 17.419 20 16.8467 20 16.25V8.75C20 8.15326 19.7629 7.58097 19.341 7.15901C18.919 6.73705 18.3467 6.5 17.75 6.5V6.5ZM17.2475 8L12.5 11.5625L7.7525 8H17.2475ZM17.75 17H7.25C7.05109 17 6.86032 16.921 6.71967 16.7803C6.57902 16.6397 6.5 16.4489 6.5 16.25V8.9375L12.05 13.1C12.1798 13.1974 12.3377 13.25 12.5 13.25C12.6623 13.25 12.8202 13.1974 12.95 13.1L18.5 8.9375V16.25C18.5 16.4489 18.421 16.6397 18.2803 16.7803C18.1397 16.921 17.9489 17 17.75 17Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1f9dc6e89ed49d0fccdd4b0e42893d6f.svg";
export { ForwardRef as ReactComponent };